import { forwardRef } from "react";

const convertToSlug = (label) =>
  label ? label.toLowerCase().replace(/ /g, "_") : "";

const Select = forwardRef(
  ({ label, options, valueCallback, nameCallback, name, setPollutantMetric }, ref) => (
    <>
      <label htmlFor={`${convertToSlug(label)}-input`}>{label}</label>
      <select
        className="px-3 py-2 mt-2 mb-4 text-black rounded w-full"
        data-testid={`${convertToSlug(label)}-test`}
        id={`${convertToSlug(label)}-input`}
        name={`${convertToSlug(name)}`}
        ref={ref}
        disabled={options ? false : true}
        onChange ={ e => {
          if(setPollutantMetric){
            const selectedIndex = e.target.options.selectedIndex;
            const alias = e.target.options[selectedIndex].getAttribute('data-key')
            setPollutantMetric(alias)
          }
        }}
      >
        <>
          {Object.keys(options).map((key) => (
            <option
              value={
                valueCallback ? valueCallback(options[key]) : options[key].id
              }
              key={key}
              data-key={options[key].alias}
            >
              {nameCallback ? nameCallback(options[key]) : options[key].name}
            </option>
          ))}
        </>
      </select>
    </>
  )
);

export default Select;
